import type { Auth } from "firebase/auth";
import { getFirebaseApp } from "./app";

// firebase/auth is de volledige e-mail/wachtwoord-SDK (login, registratie, tokens, ...) —
// alleen nodig zodra iemand écht inlogt/de accountstatus opvraagt. Vroeger een statische
// import, dus liep 'ie altijd mee in de kritieke eerste-bundel (élke pagina, ook wie nooit
// inlogt). Nu een dynamische import, gecacht: pas geladen bij de eerste écht aanroep.
let authModPromise: Promise<typeof import("firebase/auth")> | null = null;
export function loadAuthModule(): Promise<typeof import("firebase/auth")> {
  if (!authModPromise) authModPromise = import("firebase/auth");
  return authModPromise;
}

let client: Auth | null = null;
export async function getAuthClient(): Promise<Auth> {
  if (client) return client;
  const { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } = await loadAuthModule();
  // Bewust `initializeAuth` en NIET `getAuth`: die laatste hangt er standaard de
  // popup/redirect-resolver aan, en die haalt bij elke paginalading een iframe van
  // apis.google.com op om te kijken of er een inlog-redirect openstaat. Wij loggen alleen met
  // e-mail/wachtwoord in (geen Google/Facebook-knop), dus dat is werk voor niets — het kostte
  // élke bezoeker een extra verzoek plus main-thread-tijd. Persistence expliciet meegeven,
  // anders valt 'ie terug op geen persistence en is iedereen bij een herlaadbeurt uitgelogd.
  client = initializeAuth(getFirebaseApp(), { persistence: [indexedDBLocalPersistence, browserLocalPersistence] });
  return client;
}
